import React, { useEffect } from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SearchIcon from "@mui/icons-material/Search";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import Logo from "../image/logo.png";
import moment from "moment";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import { Grid,Box, TextField,IconButton } from "@mui/material";
import { BASE_URL } from "./../../global";
import ExcelDownload from "../../utils/components/excelDownload";
import html2pdf from "html2pdf.js";
import { toPng } from "html-to-image";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import DownloadPdfLoaderModal from "../../utils/components/downloadPdfLoader";
import { toast } from "react-toastify";
import ListWrap from "../commonComponent/listWrap";
import { getFormattedDates } from "../../utils/utils";
import { parseRange } from "../../utils/components/accuracyandlcandrangesshow";

const columns = [
  { id: "id", label: "Sr.No.", minWidth: 1 },
  { id: "SRFNoDate", label: "SRF No & Date", minWidth: 10 },
  { id: "DCNo", label: "DC No", minWidth: 10 },
  { id: "DCDate", label: "DC Date", minWidth: 10 },
  { id: "ulrNo", label: "ULR Number", minWidth: 10 },
  { id: "address", label: "Customer Address", minWidth: 10 },
  { id: "Description", label: "Description", minWidth: 10 },
  {
    id: "makemodel",
    label: "Make / Model",
    minWidth: 10,
    align: "left",
  },
  {
    id: "ranges",
    label: "Range",
    minWidth: 10,
    align: "left",
  },
  {
    id: "lc",
    label: "LC",
    minWidth: 10,
    align: "left",
  },
  {
    id: "serialNumberducId",
    label: "SL No / ID No",
    minWidth: 10,
    align: "left",
  },
  {
    id: "ConOfDuc",
    label: "Visual Condition",
    minWidth: 10,
    align: "left",
  },
  {
    id: "dueDate",
    label: "Calibration Date",
    minWidth: 10,
    align: "left",
  },
  {
    id: "calibratedBy",
    label: "Calibrated By",
    minWidth: 10,
    align: "left",
  },
  {
    id: "approvedBy",
    label: "Approved By",
    minWidth: 10,
    align: "left",
  },
  {
    id: "issueDate",
    label: "Date of Issue",
    minWidth: 10,
    align: "left",
  },
  {
    id: "billnodate",
    label: "BillNo & date",
    minWidth: 15,
    align: "left",
  },
  {
    id: "Remarks",
    label: "Remarks",
    minWidth: 10,
    align: "left",
  },
];

function createData(
  id,
  SRFNoDate,
  DCNo,
  DCDate,
  ulrNo,
  address,
  Description,
  makemodel,
  ranges,
  lc,
  serialNumberducId,
  ConOfDuc,
  dueDate,
  calibratedBy,
  approvedBy,
  issueDate,
  companyHierarchy,
  billnodate,
  Remarks
) {
  return {
    id,
    SRFNoDate,
    DCNo,
    DCDate,
    ulrNo,
    address,
    Description,
    makemodel,
    ranges,
    lc,
    serialNumberducId,
    ConOfDuc,
    dueDate,
    calibratedBy,
    approvedBy,
    issueDate,
    companyHierarchy,
    billnodate,
    Remarks,
  };
}
let notNeededColumn = ["id"];
export default function InwardRegister() {
  const [page, setPage] = React.useState(0);
  const [customer, setCustomer] = React.useState(0);
  const [from, setFrom] = React.useState("");
  const [data, setData] = React.useState("");
  const [to, setTo] = React.useState("");
  const [rowsPerPage, setRowsPerPage] = React.useState(30);
  const [dateData, setDateData] = React.useState([]);
  const [calData, setCalData] = React.useState([]);
  const [ids, setIds] = React.useState([]);
  const _clientId = localStorage.getItem("clientId");
  const _userType = localStorage.getItem("type");
  const [settingList, setSettingList] = React.useState({});
  const _companyHierarchy = localStorage.getItem("companyHierarchy");
  const printComponentRef = React.useRef();
  const [downloadPdfloading, setDownlaodPdfLoading] = React.useState(false);
  const [isPrint, setIsPrint] = React.useState(false);
  const [address, setaddress] = React.useState([]);
  const [searched, setSearched] = React.useState(false);

  const FilterData = () => {
    let resultProductData;

    // Filter by date range and selected companies
    resultProductData = data?.filter((datas) => {
      const isDateInRange =
        new Date(datas.srfs_entryDate) >=
          new Date(from).setHours(0, 0, 0, 0) &&
        new Date(datas.srfs_entryDate) <=
          new Date(to).setHours(23, 59, 59, 999);

      const isHierarchyMatched =
        _userType === "3"
          ? _companyHierarchy == datas.srfs_companyHierarchy
          : true;

      return isDateInRange && isHierarchyMatched;
    });

    // Update the state with filtered data
    setDateData(resultProductData);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const [userList, setuserList] = React.useState([]);
  const getUserList = () => {
      let url = BASE_URL;
      axiosWithToken
        .get(url + "users")
        .then((res) =>setuserList(res.data))
       .catch((err)=>console.log(err));
    };

  const getCustomer = (event) => {
    let url = BASE_URL;
    let endPoint = "";
    endPoint =
      _userType == "3"
        ? `clients/${_clientId}?_where=(status,eq,1)`
        : `clients?_where=(status,eq,1)`;
    axiosWithToken
      .get(url + endPoint)
      .then((res) => {
        setCustomer(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  var pushArray = [];

  for (let i = 0; i < customer.length; i++) {
    pushArray.push({
      id: customer[i].id,
      label: customer[i].companyName,
    });
  }

  const fetchAddresses = async () => {
    return axiosWithToken
      .get(BASE_URL + `addresses`)
      .then((res) => setaddress(res.data))
      .catch((error) => {
        console.error("Error fetching address:", error);
      });
  };

  const getData = (event) => {
    let url = BASE_URL;
    let whereConditions = "where certificates.status != -1";
    if (to != null && from != null) {
          const { fromDate, toDate } = getFormattedDates(from, to);
          if (whereConditions === "") {
            whereConditions = " and ";
          } else {
            whereConditions += " and ";
          }
    
          whereConditions += ` srfs.entryDate between '${fromDate}' and '${toDate}'`;
        }

    axiosWithToken
      .post(
        url + 'dynamic' ,
          // "xjoin?_join=ds.datasheets,_j,client.clients,_j,inst.instruments,_j,srfs.srfs,_j,cert.certificates,_j,srfsinst.srfInstruments&_on1=(ds.clientId,eq,client.id)&_on2=(ds.instrumentId,eq,inst.id)&_on3=(ds.serviceReqNumber,eq,srfs.serviceReqNumber)&_on4=(cert.id,eq,ds.id)&_on5=(cert.id,eq,srfsinst.id)&_fields=client.companyName,client.contact,srfs.address,inst.instrumentName,cert.ULRNo,cert.certificateNumber,cert.approvedDate,ds.calibrationDate,ds.dateOfIssue,client.id,ds.id,ds.lc,ds.DUCID,ds.make,ds.model,ds.ranges,srfs.companyHierarchy,srfs.entryDate,srfs.serviceReqNumber,srfsinst.ConOfDuc,srfs.dcDate,srfs.dcNumber,ds.accuracy,ds.serialNumber"
          {
            query:`select clients.companyName as client_companyName, clients.contact, srfs.address as srfs_address, inst.instrumentName as inst_instrumentName, certificates.ULRNo as cert_ULRNo, certificates.certificateNumber, certificates.approvedDate as cert_approvedDate, ds.calibratedby as ds_calibratedby, certificates.approvedby as cert_approvedby, certificates.dateOfIssue as cert_dateOfIssue, ds.calibrationDate, ds.dateOfIssue, clients.id AS clients_id, ds.id AS ds_id, ds.lc as ds_lc, ds.DUCID as ds_DUCID, ds.make as ds_make, ds.model as ds_model, ds.ranges as ds_ranges, srfs.companyHierarchy as srfs_companyHierarchy, srfs.entryDate as srfs_entryDate, srfs.serviceReqNumber as srfs_serviceReqNumber, srfInstruments.ConOfDuc as srfsinst_ConOfDuc, srfInstruments.requestedDucName as srfsinst_requestedDucName, srfs.dcDate as srfs_dcDate, srfs.dcNumber as srfs_dcNumber, ds.accuracy, ds.serialNumber as ds_serialNumber FROM datasheets ds left JOIN clients ON ds.clientId = clients.id left JOIN instruments inst ON ds.instrumentId = inst.id left JOIN srfs srfs ON ds.serviceReqNumber = srfs.serviceReqNumber left JOIN certificates ON certificates.id = ds.id left JOIN srfInstruments ON certificates.id = srfInstruments.id ${whereConditions}`
          }
      )
      .then(async (res) => {
        const fetchedData = res.data;
        setDateData(fetchedData);
        initializeRowTable()
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const formatDate = (date) => {
    return date ? moment(date).format("DD-MM-YYYY") : "";
  };
  const initializeRowTable = () => {
    var rowData = [];
    var idAr = [];
    for (let i = 0; i < dateData.length; i++) {
      idAr.push(dateData[i].ds_id);
      rowData.push(
        createData(
          dateData[i].ds_id,
          `${
            dateData[i].srfs_serviceReqNumber
              ? dateData[i].srfs_serviceReqNumber
              : ""
          }\n${formatDate(dateData[i].srfs_entryDate)}`,
          dateData[i].srfs_dcNumber ? dateData[i].srfs_dcNumber : "",
          formatDate(dateData[i].srfs_dcDate),
          dateData[i].cert_ULRNo,
          `${dateData[i].client_companyName}\n${address.find((el) => el.id == dateData[i].srfs_address?.split(",")[0])
            ?.address || ""}`,
          dateData[i].srfsinst_requestedDucName ? dateData[i].srfsinst_requestedDucName : dateData[i].inst_instrumentName,
          `${dateData[i].ds_make} / ${dateData[i].ds_model}`,
         parseRange(dateData[i].ds_ranges),
          parseRange(  dateData[i].ds_lc),
          `${dateData[i].ds_serialNumber} / ${dateData[i].ds_DUCID}`,
          dateData[i].srfsinst_ConOfDuc,
          formatDate(dateData[i].cert_approvedDate),
          userList?.find(user => user.id == dateData[i].ds_calibratedby)?.userName || "",
          userList?.find(user => user.id == dateData[i].cert_approvedby)?.userName || "",
          formatDate(dateData[i].cert_dateOfIssue),
          dateData[i].srfs_companyHierarchy,
        )
      );
    }
    setCalData(rowData);
    setIds(idAr);
  };

  function fetchSettings() {
    axiosWithToken
      .get(BASE_URL + `settings?_where=(status,eq,1)`)
      .then((res) => {
        let settings = res.data;
        let _settingList = {};
        settings.forEach((setting) => {
          _settingList[setting.keyName] = setting.value;
        });
        setSettingList(_settingList);
      })
      .catch((err) => {
        console.error("Error fetching setting:", err);
        if (err.message !== "request_aborted") {
          toast.error(err.message);
        }
      });
  }

  const generateDynamicHeader = async () => {
    let htmlString = `
    <div style="width:100%;margin:auto;padding:0px 29px 0px 31px;">
    <div style="border: 1px solid black;">
        <div style="text-align: left; padding: 5px 0;background:white;">
            <img src=${Logo} height="60px" alt="Logo" />
        </div>
        <div style="text-align: center; padding: 5px 0; border-top: 1px solid black; border-bottom: none;">
            <h6 style="font-size:1.2rem;"><b>Incoming Register Format</b></h6>
        </div>
    </div>
       </div>`;
    let htmlNode = document.getElementById("header-section");
    htmlNode.innerHTML = htmlString;
    let image = await toPng(htmlNode, { quality: 1, pixelRatio: 3 });
    const img = new Image();
    img.src = image;
    htmlNode.innerHTML = "";
    return img;
  };

  const generateDynamicFooter = async () => {
    let htmlString = `
    <div style="width:100%;margin:auto;padding:30px 29px 30px 31px;">
    <table style="width:100%;">
        <tr>
        <td style="padding:1px 5px;width:50%;text-align: left;font-family: Calibri, sans-serif;">
                <b style="font-size:13px;">Prepared & Issued By : QM</b>
            </td>
             <td style="padding:1px 5px;width:50%;text-align: left;font-family: Calibri, sans-serif;">
                <b style="font-size:13px;">Approved By : CMD</b>
            </td>
        <tr>
        <tr>
        <td style="padding:1px 5px;width:50%;text-align: left;font-family: Calibri, sans-serif;">
                <b style="font-size:13px;">Name : Vishal </b>
            </td>
             <td style="padding:1px 5px;width:50%;text-align: left;font-family: Calibri, sans-serif;">
                <b style="font-size:13px;">Name : Pravin</b>
            </td>
        <tr>
        <tr>
        <td style="padding:1px 5px;width:50%;text-align: left;font-family: Calibri, sans-serif;">
                <b style="font-size:13px;">Signature : </b>
            </td>
             <td style="padding:1px 5px;width:50%;text-align: left;font-family: Calibri, sans-serif;">
                <b style="font-size:13px;">Signature : </b>
            </td>
        <tr>
        </table>
        <div style="text-align: left;">
        <b style="font-size:12px;">BFI/7.4/FF/01</b>
         <b></div>
       </div>`;
    let htmlNode = document.getElementById("header-section");
    htmlNode.innerHTML = htmlString;
    let image = await toPng(htmlNode, { quality: 1, pixelRatio: 3 });
    const img = new Image();
    img.src = image;
    htmlNode.innerHTML = "";
    return img;
  };

  const generatePDF = async () => {
    setDownlaodPdfLoading(true);
    try {
      const element = printComponentRef.current;
      let pdf = await html2pdf()
        .from(element)
        .set({
          margin: [82, 1, 74, 1],
          filename: `masterInOut.pdf`,
          pagebreak: { after: "section", mode: ["css", "legacy"] },
          html2canvas: {
            dpi: 192,
            scale: 2.5,
            letterRendering: true,
            useCORS: true,
          },
          image: { type: 'png', quality: 0.4 },
          jsPDF: {
            orientation: "landscape",
            unit: "pt",
            format: "a4",
          },
        })
        .toPdf()
        .get("pdf");

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(9);
        pdf.setTextColor(0, 0, 0);
        pdf.setFont("helvetica", "bold");

        // border add for contnet
        const borderWidth = 0.6;
        const leftMargin = 23;
        const borderX = leftMargin;
        const borderY = 80;
        const rightMargin = 840 - leftMargin * 0.95;
        pdf.setLineWidth(borderWidth);
        pdf.rect(borderX, borderY, rightMargin - leftMargin, 445);

        let image = await generateDynamicHeader();
        pdf.addImage(image, 0, 5, 840, 70);
        
        image = await generateDynamicFooter();
        pdf.addImage(image, 0, 515, 840, 90);

      }

      const blob = pdf.output("blob");
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `inwardregister.pdf`;
      a.click();

      setDownlaodPdfLoading(false);

      refresh();
    } catch (error) {
      console.error("Error generating PDF:", error);
      setDownlaodPdfLoading(false);
    }
  };

  var refresh = () => {
    window.location.reload(false);
  };

  const TablePaginationActions = (props) => {
        const theme = useTheme();
        const { count, page, rowsPerPage, onPageChange } = props;
    
        const handleFirstPageButtonClick = (event) => {
          onPageChange(event, 0);
        };
    
        const handleBackButtonClick = (event) => {
          onPageChange(event, page - 1);
        };
    
        const handleNextButtonClick = (event) => {
          onPageChange(event, page + 1);
        };
    
        const handleLastPageButtonClick = (event) => {
          onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
        };
    
        return (
          <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
              onClick={handleFirstPageButtonClick}
              disabled={page === 0}
              aria-label="first page"
            >
              {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
              onClick={handleBackButtonClick}
              disabled={page === 0}
              aria-label="previous page"
            >
              {theme.direction === "rtl" ? (
                <KeyboardArrowRight />
              ) : (
                <KeyboardArrowLeft />
              )}
            </IconButton>
            <IconButton
              onClick={handleNextButtonClick}
              disabled={page >= Math.ceil(count / rowsPerPage) - 1}
              aria-label="next page"
            >
              {theme.direction === "rtl" ? (
                <KeyboardArrowLeft />
              ) : (
                <KeyboardArrowRight />
              )}
            </IconButton>
            <IconButton
              onClick={handleLastPageButtonClick}
              disabled={page >= Math.ceil(count / rowsPerPage) - 1}
              aria-label="last page"
            >
              {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
          </Box>
        );
      };

  const search = () => {
    getData();
    setSearched(true);
  };
  const clearSearch = () => {
    setSearched(false);
    setFrom("");
    setTo("");
    setDateData([]);
  };

  const handleBillnoChange = (id, value) => {
    setCalData((prev) =>
      prev.map((row) => (row.id === id ? { ...row, billnodate: value } : row))
    );
  };

  const handleRemarksChange = (id, value) => {
    setCalData((prev) =>
      prev.map((row) => (row.id === id ? { ...row, Remarks: value } : row))
    );
  };

  useEffect(() => {
    getCustomer();
    fetchSettings();
    fetchAddresses();
    getData();
    getUserList();
  }, []);

  useEffect(() => {
    initializeRowTable();
  }, [dateData]);

  return (
    <ListWrap>
        <Grid
          container
          spacing={1}
          justifyContent={"start"}
          alignItems={"center"}
        >
          <Grid item xs={6} sm={3} md={1} lg={1.5} textAlign={"left"}>
            <TextField
              id="Start Date"
              label="Date From"
              variant="outlined"
              type="date"
              className="Listinputcss"
              required={true}
              InputLabelProps={{ shrink: true }}
              size="small"
              value={from}
              onChange={(e) => {
                setFrom(e.target.value);
                setSearched(false);
              }}
            />
          </Grid>

          <Grid item xs={6} sm={3} md={1} lg={1.5} textAlign={"left"}>
            <TextField
              id="Start Date"
              label="Date To"
              variant="outlined"
              type="date"
              className="Listinputcss"
              required={true}
              InputLabelProps={{ shrink: true }}
              size="small"
              value={to}
              onChange={(e) => {
                setTo(e.target.value);
                setSearched(false);
              }}
            />
          </Grid>
          <Grid item xs={3} sm={3} md={3} lg={1} textAlign={"left"}>
            <Button
              variant="contained"
              size="small"
              sx={{ m: 0 }}
              color={searched ? "error" : "primary"}
              onClick={() => {
                searched ? clearSearch() : search();
              }}
            >
              {searched ? <RestartAltIcon /> : <SearchIcon />}
            </Button>
          </Grid>
          {calData.length > 0 && (
            <>
              <Grid item xs={4} sm={3} md={3} lg={2} textAlign={"left"}>
                <ExcelDownload
                  finalData={calData}
                  notNeededColumn={notNeededColumn}
                />
              </Grid>
              <Grid item xs={4} sm={3} md={3} lg={2} textAlign={"left"}>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => {
                    setIsPrint(true);
                    generatePDF();
                  }}
                >
                  Download PDF
                </Button>
              </Grid>
            </>
          )}
        </Grid>

        <TableContainer>
          <div
            style={{
              width: isPrint ? "95%" : "100%",
              margin: "auto",
              padding: isPrint ? "5px 7px" : "0px",
            }}
            ref={printComponentRef}
          >
            <Table
              stickyHeader
              aria-label="sticky table"
              size="small"
              style={{
                borderCollapse: "collapse",
                marginTop: isPrint ? "0px" : "5px",
              }}
            >
              <TableBody className="single-border-table">
                <TableRow>
                  {columns?.map((column) =>
                    !settingList["companyHierarchy"] &&
                    column.id === "companyHierarchy" ? null : (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{
                          width: `${column.minWidth}%`,
                          fontSize: isPrint ? "9.2px" : "12px",
                          padding: isPrint ? "1px 6px" : "6px 16px",
                        }}
                      >
                        <b>{column.label}</b>
                      </TableCell>
                    )
                  )}
                </TableRow>
                {calData?.length > 0 ? (
                  calData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      return (
                        <TableRow
                          id="pagbreaksborder"
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index}
                          style={{ pageBreakInside: "avoid" }}
                        >
                          {columns?.map((column) => {
                            let value = row[column.id];

                            if (column.id === "id") {
                              value = page * rowsPerPage + index + 1;
                            }

                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  fontSize: isPrint ? "9.2px" : "12px",
                                  padding: isPrint ? "1px 6px" : "6px 6px",
                                }}
                              >
                                {isPrint ? (
                                  column.id === "billnodate" ||
                                  column.id === "Remarks" ? (
                                    value
                                  ) : column.format &&
                                    typeof value === "number" ? (
                                    column.format(value)
                                  ) : (
                                    value
                                  )
                                ) : column.id === "billnodate" ? (
                                  <TextField
                                    variant="standard"
                                    size="small"
                                    value={row.billnodate || ""}
                                    onChange={(e) =>
                                      handleBillnoChange(row.id, e.target.value)
                                    }
                                    style={{ width: "100%" }}
                                  />
                                ) : column.id === "Remarks" ? (
                                  <TextField
                                    variant="standard"
                                    size="small"
                                    value={row.Remarks || ""}
                                    onChange={(e) =>
                                      handleRemarksChange(
                                        row.id,
                                        e.target.value
                                      )
                                    }
                                    style={{ width: "100%" }}
                                  />
                                ) : column.format &&
                                  typeof value === "number" ? (
                                  column.format(value)
                                ) : (
                                  value
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length + 1} align="center">
                      <h6>
                        <b>Data Not Found</b>
                      </h6>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          <div style={{ width: "100%" }} id="header-section"></div>

          <TablePagination
            rowsPerPageOptions={[10, 30, 50, 100]}
            component="div"
            count={calData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </TableContainer>
        {downloadPdfloading && (
          <DownloadPdfLoaderModal
            loading={downloadPdfloading}
            name={"Summary Report"}
          />
        )}

    </ListWrap>
  );
}
